module.exports = __webpack_public_path__ + "img/W-G26.cd024e05.jpg";